module.exports = __webpack_public_path__ + "img/calendar.c4e3964d.svg";